/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseCouponParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['createdAt', parsers.moment, 'created_at'],
    ['limit', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
    ['usedAmount', codecNumber, 'used_amount'],
]);
export class BaseCoupon extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseCouponParser.decode(input).map(res => new BaseCoupon(res));
    }
    static unsafeDecode(input) {
        return BaseCoupon.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCouponParser.encode(data);
    }
    static schema() {
        return BaseCouponParser.schema();
    }
}
